<template>
    <div class="pa-2">
      <v-dialog v-model="showReportDialog">
        <report-viewer v-if="showReportDialog"
          :reportName="Report_Name"
          :dataUrl="Report_URL"
          ref="reportViewer" />
      </v-dialog>
       
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <h3>Manage dog name</h3>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row class="mt-1">
            <v-col cols="6">
                <v-card class="elevation-2" outlined>
                    <v-card-title>
                        Manually managed programs
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field v-model="dogInfo.manualPrefix"
                                              label="Manual Prefix"
                                              :disabled="!isEditNames"
                                              outlined></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field v-model="dogInfo.manualSuffix"
                                              label="Manual Suffix"
                                              :disabled="!isEditNames"
                                              outlined></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-spacer />
                      <v-btn v-if="!isEditNames" v-on:click="toggleEditNames" color="primary">
                         <font-awesome-icon icon="pencil-alt" />
                           Edit
                      </v-btn>
                      <v-btn v-else color="primary"
                          v-on:click="updateManualPrefixSuffix"
                          class="my-auto"
                          style="vertical-align: middle">
                          <font-awesome-icon icon="check" />
                             Save
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col>
                <v-card class="elevation-2" outlined>
                    <v-card-title>
                        HOF
                    </v-card-title>
                    <v-card-text>
                        <v-checkbox 
                          :disabled="!isEditingHof"
                          v-model="dogInfo.isHof" 
                          label="Hall of Fame" />
                        <datepicker
                          :disabled="!isEditingHof"
                          :date="dogInfo.hofDate"
                          label="HOF Date"
                          v-on:updateDates="updateDogDates($event, 'hofDate')"
                        />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-spacer />
                      <v-btn v-if="!isEditingHof" v-on:click="toggleEditingHof" color="primary">
                         <font-awesome-icon icon="pencil-alt" />
                           Edit
                      </v-btn>
                      <v-btn v-else color="primary"
                          v-on:click="updateDogHofStatus"
                          class="my-auto"
                          style="vertical-align: middle">
                          <font-awesome-icon icon="check" />
                             Save
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col>
                <v-card class="elevation-2" outlined>
                    <v-card-title>
                        DNA
                    </v-card-title>
                    <v-card-text>
                          <v-select 
                            :disabled="!isEditingDna"
                            v-model="dogInfo.dnaStatus" 
                            :items="dnaStatuses"
                            item-text="description"
                            item-value="id"
                            label="DNA Status"
                            clearable
                            />
                        <datepicker 
                          :disabled="!isEditingDna"
                          :date="dogInfo.dnaDate"
                          label="DNA Date"
                          v-on:updateDates="updateDogDates($event, 'dnaDate')"
                        />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-spacer />
                      <v-btn v-if="!isEditingDna" v-on:click="toggleEditingDna" color="primary">
                         <font-awesome-icon icon="pencil-alt" />
                           Edit
                      </v-btn>
                      <v-btn v-else color="primary"
                          v-on:click="updateDogDnaStatus"
                          class="my-auto"
                          style="vertical-align: middle">
                          <font-awesome-icon icon="check" />
                             Save
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

        </v-row>

        <v-card class="elevation-2 mt-1" outlined>
            <v-card-title>
                Current name: {{ dogInfo.dogFullName }}
                <v-spacer />
                <v-btn class="mr-1" color="primary"
                       v-on:click="generateDogName">
                    Re-generate
                </v-btn>
                <v-btn v-on:click="loadDogData" color="primary">
                  Reload dog data
                </v-btn>
            </v-card-title>         
            <v-card-text>
                <v-row>
                  <v-col cols="4">
                    <v-text-field v-model="dogName.prefix"
                      label="Prefix"
                      disabled
                        />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="dogName.dogName"
                      label="Registered Name"
                      disabled
                       />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="dogName.suffix"
                      label="Suffix"
                      disabled
                       />
                  </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-spacer />
                <v-btn color="primary"
                    :disabled="!isRegeneratingName"
                    v-on:click="updateprefixSuffix">
                    Save re-generated name
                </v-btn>
            </v-card-actions>
        </v-card>
     
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
        <v-card outlined class="mt-3">
            <v-card-text>
                <v-data-table :headers="certificatesHeaders"
                              :items="titles"
                              style="font-size: 9pt"
                              dense
                              hide-default-footer
                              :items-per-page="-1"
                              height="93vh"
                              fixed-header
                              :search="search">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-text-field v-model="search"
                                          append-icon="mdi-magnify"
                                          label="Search"
                                          class="ml-1"
                                          single-line
                                          hide-details
                                          clearable>
                            </v-text-field>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="1000px" persistent>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary"
                                           dark
                                           class="mb-2"
                                           v-bind="attrs"
                                           v-on="on">
                                        New Title
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="text-h5">{{ isNewTitle ? "New Title" : "Edit Title" }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete v-model="editedItem.categoryId"
                                                                    label="Title"
                                                                    :items="titleChoices"
                                                                    :filter="filterCategoriesByDisplayText"
                                                                    :item-text="(item) => `${item.programName}: ${item.categoryId}`"
                                                                    :item-value="(item) => item.categoryId"
                                                                    clearable
                                                                    auto-select-first
                                                                    v-on:change="(e) => changeProgramAndDesc(e)"
                                                                    v-if="isNewTitle"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-text-field v-model="editedItem.categoryId"
                                                                  label="Title"
                                                                  disabled></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-text-field v-model="editedItem.programName"
                                                                  label="Program"
                                                                  disabled></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-textarea v-model="editedItem.description"
                                                                label="Description"
                                                                disabled
                                                                rows="1"
                                                                auto-grow></v-textarea>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <datepicker
                                                      :date="editedItem.showDate"
                                                      label="Show Date"
                                                      v-on:updateDates="updateDates($event, 'showDate')" />
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-checkbox
                                                        v-model="editedItem.isPrinted"
                                                        label="Printed" />
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-text-field v-model="editedItem.certificateNumber"
                                                                  label="Certificate Number"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="close">
                                            Cancel
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="save">
                                            Save
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="dialogDelete" max-width="500px">
                                <v-card>
                                    <v-card-title style="word-break: break-word" class="text-h5">
                                        Are you sure you want to delete this title?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="closeDelete">
                                            Cancel
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                                            OK
                                        </v-btn>
                                        <v-spacer />
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.showDate="{ item }">
                        <span v-if="item.showDate">
                            <localized-date :date="item.showDate" />
                        </span>
                    </template>
                    <template v-slot:item.printedAt="{ item }">
                        <localized-date-time v-if="item.printedAt" :instant="item.printedAt" />
                    </template>
                    <template v-slot:item.categoryId="{ item }">
                        <v-chip small
                                pill
                                :color="getTitleColor(item.categoryId, item.categoryId)"
                                dark>
                            {{ item.categoryId }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                        <v-icon small class="mr-2" @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                        <v-icon small
                          @click="selectedTitle = item.certificateId;
                          (item.isSuffix && !(item.categoryId.includes('DNA'))) ? showTitleDialog() : showTitleDialogFull();                
                        ">
                            mdi-printer
                        </v-icon>
                    </template>
                </v-data-table>
                <v-snackbar v-model="snackbar" :color="snackbarColor" title>
                    {{ snackbarText }}

                    <template v-slot:action="{ attrs }">
                        <v-btn color="dark" text v-bind="attrs" @click="snackbar = false">
                            Close
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card-text>
        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import ReportViewer from "../../../Admin/Reports/ReportViewer.vue";
import Datepicker from "../../../common/inputs/DatepickerFormatted.vue";

import dogService from "@/services/dogService";
import lookupsService from "@/services/lookupsService";

import adminDogService from "@/services/admin/dogService";
import categoryService from "@/services/admin/categoryService";
import adminTitlingService from "@/services/admin/titlingService";
import { getErrorMessage } from "@/services/errorHandler";

import { UserInfo } from "@/types/User";
import { Messages } from "@/constants";

export default Vue.extend({
  name: "Titles",
    props: {
        dogId: String
    },
  components: {
    ReportViewer,
    Datepicker,
  },
  data: function () {
    return {
      Report_Name: 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx',
      Report_URL: '`/Admin/reports/certificate/${selectedTitle}`',
      showReportDialog: false,
      dialog: false,
      dialogDelete: false,
      titles: [] as any,
      dnaStatuses: [] as any,
      certificatesHeaders: [
        { text: "Program", align: "left", value: "programName" },
        { text: "Title", align: "left", value: "categoryId" },
        { text: "Description", align: "left", value: "description" },
        { text: "Show Date", align: "left", value: "showDate" },
        { text: "Printed At", align: "left", value: "printedAt" },
        {
          text: "Certificate Number",
          align: "left",
          value: "certificateNumber",
        },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      colors: [
        "#e51c23",
        "#e91e63",
        "#9c27b0",
        "#673ab7",
        "#3f51b5",
        "#5677fc",
        "#03a9f4",
        "#00bcd4",
        "#009688",
        "#259b24",
        "#8bc34a",
        "#afb42b",
        "#ff9800",
        "#ff5722",
        "#795548",
        "#607d8b",
      ],
      search: "",
      selectedTitle: "",
      dogInfo: {
        dnaDate: null,
        hofDate: null
      } as any,
      dogName: {
        prefix: '',
        suffix: '',
        dogName: '',
      } as any,
      isEditNames: false,
      isEditingHof: false,
      isEditingDna: false,
      isRegeneratingName: false,
      editedIndex: -1,
      editedItem: {
        programName: "",
        title: "",
        description: "",
        showDate: null,
        printedAt: null,
        isPrinted: false,
        certificateNumber: "",
      },
      defaultItem: {
        programName: "",
        title: "",
        description: "",
        showDate: null,
        printedAt: null,
        isPrinted: false,
        certificateNumber: "",
      },
      titleChoices: [],
      snackbar: false,
      snackbarColor: "green",
      snackbarText: "",
    };
  },
  created() {
    this.loadDogData();
  },
   methods: { 
    showTitleDialog: function (){   
      this.Report_Name = "Asca.Api.Reports.rpt8110_Title_Certificate.rdlx";
      this.Report_URL = "/Admin/reports/certificate/"+this.selectedTitle;
      this.showReportDialog = true;
    },
    showTitleDialogFull: function (){
      this.Report_Name = "Asca.Api.Reports.rpt8111_Title_Certificate_Full.rdlx";
      this.Report_URL = "/Admin/reports/certificate/"+this.selectedTitle;
      this.showReportDialog = true;
    },
      loadDogData() {        
        lookupsService.getDnaStatuses().then((res: any) => {
          this.dnaStatuses = res;
        });
        adminDogService
          .getDogTitlesInfoById(this.dogId)
          .then((res: any) => {
            this.dogInfo = res;
            this.dogName = {
              prefix: res.prefix,
              suffix: res.suffix,
              dogName: res.name,
            };
            this.titles = res.titles;
          });
        categoryService.getTitleCategories().then((res) => {
          this.titleChoices = res.certificateCategories;      
        });
      },
    updateDogDnaStatus() {
      this.$store.dispatch("changeLoaderStatus",true);
      adminDogService.updateDogDnaStatus (
        this.dogId, 
        {
          dogId: this.dogId,
          dnaStatusId: this.dogInfo.dnaStatus,
          dnaDate: this.dogInfo.dnaDate ? this.dogInfo.dnaDate : null
        }
      ).then((res: any) => {
                if (res.success) {
                  this.$data.snackbar = true;
                  this.$data.snackbarColor = "green";
                  this.$data.snackbarText = Messages.SaveSuccessful;
                  this.loadDogData();
                  this.isEditingDna = false;
                } else {
                  this.$data.snackbar = true;
                  this.$data.snackbarColor = "red";
                  this.$data.snackbarText = Messages.SaveError + " " + res.messages.join(', ');
                }
          })
          .catch((e: any) => {
              this.$data.snackbar = true;
              this.$data.snackbarColor = "red";
              this.$data.snackbarText = getErrorMessage(e);
          })
          .finally(() => this.$store.dispatch("changeLoaderStatus",false));
    },
    updateDogHofStatus() {
      this.$store.dispatch("changeLoaderStatus",true);
      adminDogService.updateDogHofStatus(
        this.dogId, 
        {
          dogId: this.dogId,
          isHof: this.dogInfo.isHof,
          hofDate: this.dogInfo.hofDate ? this.dogInfo.hofDate : null
        }
      ).then((res: any) => {
                if (res.success) {
                  this.$data.snackbar = true;
                  this.$data.snackbarColor = "green";
                  this.$data.snackbarText = Messages.SaveSuccessful;
                  this.loadDogData();
                  this.isEditingHof = false;
                } else {
                  this.$data.snackbar = true;
                  this.$data.snackbarColor = "red";
                  this.$data.snackbarText = Messages.SaveError + res.messages.join(', ');
                }
          })
          .catch((e: any) => {
              this.$data.snackbar = true;
              this.$data.snackbarColor = "red";
              this.$data.snackbarText = getErrorMessage(e);
          })
          .finally(() => this.$store.dispatch("changeLoaderStatus",false)); 
    },
      generateDogName() {
          adminTitlingService.getGeneratedNameForDog(this.dogId)
            .then((res: any) => {
                this.dogName = res;
                this.isRegeneratingName = true;
          })
          .catch((e: any) => {            
              this.$data.snackbar = true;
              this.$data.snackbarColor = "red";
              this.$data.snackbarText = getErrorMessage(e);
          });
      },
      updateprefixSuffix() { 
        this.$store.dispatch("changeLoaderStatus",true);
        adminDogService.updatePrefixSuffix(this.dogId, this.$data.dogName.prefix, this.$data.dogName.suffix)
            .then((res: any) => {
                if (res.success) {
                  this.$data.snackbar = true;
                  this.$data.snackbarColor = "green";
                  this.$data.snackbarText = Messages.SaveSuccessful;
                  this.isRegeneratingName = false;
                  this.loadDogData();
                  this.$emit('update:dogNamePrefix', this.$data.dogName.prefix);
                  this.$emit('update:dogNameSuffix', this.$data.dogName.suffix);
                } else {
                  this.$data.snackbar = true;
                  this.$data.snackbarColor = "red";
                  this.$data.snackbarText = Messages.SaveError;
                }
          })
          .catch((e: any) => {
              this.$data.snackbar = true;
              this.$data.snackbarColor = "red";
              this.$data.snackbarText = Messages.SaveError;;
          })
          .finally(() => this.$store.dispatch("changeLoaderStatus",false));
      },
    updateManualPrefixSuffix() {
      this.$store.dispatch("changeLoaderStatus",true);
      adminDogService
        .editManualPrefixSuffix(
          this.$data.dogInfo.manualPrefix,
          this.$data.dogInfo.manualSuffix,
          this.$props.dogId
        )
        .then((res) => {
          if (res.success) {
            this.$data.snackbar = true;
            this.$data.snackbarColor = "green";
            this.$data.snackbarText = Messages.SaveSuccessful;
          } else {
            this.$data.snackbar = true;
            this.$data.snackbarColor = "red";
            this.$data.snackbarText = Messages.SaveError;
          }
        })
        .catch((e: any) => {
              this.$data.snackbar = true;
              this.$data.snackbarColor = "red";
              this.$data.snackbarText = Messages.SaveError;
        })
        .finally(() => this.$store.dispatch("changeLoaderStatus",false));

      this.$data.isEditNames = !this.$data.isEditNames;
    },
    filterCategoriesByDisplayText(item: any, queryText: string, itemText: string) {
        return itemText.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
    },
    changeProgramAndDesc(e: any) {
      let idx = this.$data.titleChoices.findIndex(
        (x: any) => x.categoryId === e
      );
      if(idx !== -1){
        this.$data.editedItem.programName =
          this.$data.titleChoices[idx].programName;
        this.$data.editedItem.description =
          this.$data.titleChoices[idx].description;
        this.$data.editedItem = Object.assign({}, this.$data.editedItem);
      }
    },
    getTitleColor(titleName: string, titleId: number) {
      const text = `123${titleName}123`; //`${titleId}${titleName}${titleId}`
      var hash = 0;
      if (text.length === 0) return hash;
      for (var i = 0; i < text.length; i++) {
        hash = text.charCodeAt(i) + ((hash << 3) - hash);
        hash = hash & hash;
      }
      hash =
        ((hash % this.$data.colors.length) + this.$data.colors.length) %
        this.$data.colors.length;
      return this.$data.colors[hash];
    },
    toggleEditNames() {
      this.isEditNames = !this.isEditNames;
    },
    toggleEditingHof() {
      this.isEditingHof = !this.isEditingHof;
    },
    toggleEditingDna() {
      this.isEditingDna = !this.isEditingDna;
    },
    updateDogDates: function (val: any, key: string) {
      this.dogInfo[key] = val.date;
      this.dogInfo = Object.assign({}, this.dogInfo);
    },
    updateDates: function (val: any, key: string) {
      this.$data.editedItem[key] = val.date;
      this.$data.editedItem = Object.assign({}, this.$data.editedItem);
    },
    editItem(item: any) {
      var temp = Object.assign({}, item);
      temp.isPrinted = !!item.printedAt;
      this.$data.editedIndex = (this as any).titles.indexOf(item);
      this.$data.editedItem = Object.assign({}, temp);
      this.$data.dialog = true;
    },
    deleteItem(item: any) {
      this.$data.editedIndex = (this as any).titles.indexOf(item);
      this.$data.editedItem = Object.assign({}, item);
      this.$data.dialogDelete = true;
    },
    deleteItemConfirm() {
      adminDogService
        .deleteDogCertificate({
          dogId: this.$props.dogId,
          certId: this.$data.titles[this.$data.editedIndex].certificateId,
        })
        .then((res) => {
          if (res.success) {
            this.$data.titles = res.dogTitles;
            this.$data.snackbar = true;
            this.$data.snackbarColor = "green";
            this.$data.snackbarText = Messages.SaveSuccessful;
          } else {
            this.$data.snackbar = true;
            this.$data.snackbarColor = "red";
            this.$data.snackbarText = Messages.SaveError;
          }
        })
        .catch((e: any) => {
          this.$data.snackbar = true;
          this.$data.snackbarColor = "red";
          this.$data.snackbarText = Messages.SaveError;
        });
      (this as any).closeDelete();
    },

    close() {
      this.$data.dialog = false;
      this.$data.editedItem = Object.assign({}, this.$data.defaultItem);
      this.$data.editedIndex = -1;
    },

    save() {
      if (this.$data.editedIndex > -1) {
        Object.assign(
          (this as any).titles[this.$data.editedIndex],
          this.$data.editedItem
        );
        adminDogService
            .updateDogCertificate({
              ...this.$data.editedItem,
              dogId: this.$props.dogId,
              certId: this.$data.editedItem.certificateId,
            })
            .then((res) => {
              if (res.success) {
                this.$data.titles = res.dogTitles;
                this.$data.snackbar = true;
                this.$data.snackbarColor = "green";
                this.$data.snackbarText = Messages.SaveSuccessful;
              } else {
                this.$data.snackbar = true;
                this.$data.snackbarColor = "red";
                this.$data.snackbarText = Messages.SaveError;
              }
            })
            .catch((e: any) => {
              this.$data.snackbar = true;
              this.$data.snackbarColor = "red";
              this.$data.snackbarText = getErrorMessage(e);
        });
      } else {
        adminDogService
            .createDogCertificate({
              ...this.$data.editedItem,
              dogId: this.$props.dogId,
            })
            .then((res) => {
              if (res.success) {
                this.$data.titles = res.dogTitles;
                this.$data.snackbar = true;
                this.$data.snackbarColor = "green";
                this.$data.snackbarText = Messages.SaveSuccessful;
              } else {
                this.$data.snackbar = true;
                this.$data.snackbarColor = "red";
                this.$data.snackbarText = Messages.SaveError;
              }
            })
            .catch((e: any) => {
              this.$data.snackbar = true;
              this.$data.snackbarColor = "red";
              this.$data.snackbarText = getErrorMessage(e);
            });
      }
      (this as any).close();
    },
    closeDelete() {
      this.$data.dialogDelete = false;
      this.$data.editedItem = Object.assign({}, this.$data.defaultItem);
      this.$data.editedIndex = -1;
      },
  },
  watch: {
    dogId: function (newVal: string) {
      dogService
        .getDogTitlesById(this.dogId)
        .then((res) => {
          this.$data.titles = res;
        });
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    isNewTitle(): boolean {
      return this.$data.editedIndex === -1;
    },
  },
});

</script>
